enum ComparisonOperatorEnum {
	Equals = 'eq',
	NotEquals = 'ne',
	GreaterThan = 'gt',
	GreaterThanOrEqual = 'ge',
	LessThan = 'lt',
	LessThanOrEqual = 'le',
	Contains = 'in',
	StartsWith = 'sw',
	EndsWith = 'ew',
	Empty = 'em',
	NotEmpty = 'nm',
}

export default ComparisonOperatorEnum;
